import React from 'react';
import { FolderKanban, LayoutGrid } from 'lucide-react';

const kpiData = [
  { icon: FolderKanban, label: 'Proyectos', value: '' },
  { icon: LayoutGrid, label: 'Almacén', value: '' },
];

export const KPIChips: React.FC = () => {
  return (
    <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
      {kpiData.map((kpi, index) => (
        <div
          key={kpi.label}
          className="kpi-chip flex items-center gap-2 animate-fade-in-up"
          style={{ animationDelay: `${0.4 + index * 0.1}s`, opacity: 0 }}
        >
          <kpi.icon className="h-4 w-4 opacity-70" />
          <span className="opacity-70">{kpi.label}</span>
          <span className="font-semibold">{kpi.value}</span>
        </div>
      ))}
    </div>
  );
};

export default KPIChips;
